import { createContext, useContext } from 'react';
import type { GuideDefinition } from './guide-types.js';

export interface GuidesContextValue {
  available: readonly GuideDefinition[];
  open: (guide: GuideDefinition) => void;
}

export const GuidesContext = createContext<GuidesContextValue>({
  available: [],
  open: () => undefined,
});

export const useGuides = () => useContext(GuidesContext);
